import React from 'react';
import RoleLevelConfig from './RoleLevelConfig';
// import RuleLevelConfig from './RuleLevelConfig';

const RoleConfiguration = ({ handleChange, data, handleDeptChange, departmentData }) => (
  <>
    <RoleLevelConfig
      handleChange={handleChange}
      data={data}
      handleDeptChange={handleDeptChange}
      departmentData={departmentData}
    />
    {/* <RuleLevelConfig data={data} /> */}
  </>
);

export default RoleConfiguration;
